'use client'

import { useEffect } from "react"
import { createClient } from "@/lib/supabase/client"
import { identifyUser, trackAction } from "../../lib/tracking"
import { AuthChangeEvent } from "@supabase/supabase-js"

// handles auth state changes
export function Supabase() {
    const supabase = createClient();

    // Set up auth state change listener to identify users in PostHog
    useEffect(() => {
        // Check initial session
        const checkSession = async () => {
            const { data: { session } } = await supabase.auth.getSession();
            if (session?.user) {
                // Identify user with our tracking function
                identifyUser({
                    userId: session.user.id,
                    userProperties: {
                        email: session.user.email,
                        name: session.user.user_metadata?.full_name,
                        avatar_url: session.user.user_metadata?.avatar_url
                    }
                });
            }
        };
        
        checkSession();

        // Listen for auth state changes
        const { data: { subscription } } = supabase.auth.onAuthStateChange(
            (event: AuthChangeEvent, session) => {
                // Identify on initial session, sign in, and user updates
                if ((event === 'INITIAL_SESSION' || event === 'SIGNED_IN' || event === 'USER_UPDATED') && session?.user) {
                    // Identify user with our tracking function
                    identifyUser({
                        userId: session.user.id,
                        userProperties: {
                            email: session.user.email,
                            name: session.user.user_metadata?.full_name,
                            avatar_url: session.user.user_metadata?.avatar_url,
                            auth_event: event // Track which event triggered the identification
                        }
                    });
                } else if (event === 'SIGNED_OUT') {
                    // Track sign out event
                    trackAction('User Signed Out', { event });
                }
            }
        );

        // Cleanup subscription on unmount
        return () => {
            subscription.unsubscribe();
        };
    }, [supabase]);

    return null;
}